import { Component } from '../../../../utils';

@Component({
    controllerAs: 'vm',
    template: require('./alert.tpl.html'),
    bindings: {
        alertInfo: '<',
        useList: '<'
    }
})
export default class AlertComponent {
    constructor() {
        this.showList = true;
        if (!this.useList) {
            this.showList = this.alertInfo > 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/components/alert/alert.js